// Custom icon static resources

import { BulbOutline, ExceptionOutline, InfoOutline, LinkOutline, PlusCircleFill, ProfileOutline } from '@ant-design/icons-angular/icons';

export const ICONS = [InfoOutline, BulbOutline, ProfileOutline, ExceptionOutline, LinkOutline, PlusCircleFill];
